export default "__VITE_ASSET__D_q8Vxee__"